var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintTemp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.0621 98.6961V20.5857C94.0621 13.6327 88.4293 8 81.4764 8C74.5234 8 68.8907 13.6327 68.8907 20.5857V98.6961C60.0235 103.273 53.9287 112.492 53.9287 123.185C53.9287 138.389 66.2503 150.733 81.4764 150.733C96.7024 150.733 109.024 138.411 109.024 123.185C109.024 112.514 102.951 103.273 94.0621 98.6961Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7402 123.165C70.7402 117.224 75.5589 112.428 81.4777 112.428C87.3964 112.428 92.2151 117.246 92.2151 123.165C92.2151 129.084 87.3964 133.903 81.4777 133.903C75.5589 133.903 70.7402 129.084 70.7402 123.165Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4756 112.429V74.4736",
    stroke: "white",
    strokeWidth: 6.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 27.6484H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 39.3535H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 51.0605H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 62.7676H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 74.4707H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9512 86.1748H68.9132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 98.7598C11.1992 98.7598 22.9708 91.9609 35.2044 92.9511C42.3334 93.5231 48.9782 97.2636 52.3227 103.578C54.1269 107.011 55.2931 111.61 54.1489 117.484C54.1489 117.484 50.0564 122.787 42.3774 123.139C35.6225 123.447 29.4396 119.509 26.1612 113.612C25.7432 112.864 25.3471 112.072 24.9731 111.235C23.4549 107.869 21.4306 104.745 18.6802 102.302C16.5679 100.432 13.9716 98.8478 11.1992 98.7598Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9238 101.662C29.9238 101.662 44.6878 106.745 54.1491 117.482",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.308 133.527C109.024 133.857 110.938 134.011 113.051 133.835C121.346 133.131 128.277 127.3 131.313 119.577C131.687 118.609 132.061 117.575 132.391 116.497C133.689 112.162 135.67 108.004 138.64 104.571C140.906 101.953 143.811 99.5984 147.199 99.0263C147.199 99.0263 131.731 92.6235 116.945 95.8139C111.026 97.0901 105.636 100.148 101.829 104.615",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.8 105.605C124.8 105.605 116.681 109.676 108.386 116.959",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.85 41.8824C119.85 41.8824 125.417 50.7275 125.021 60.1668C124.779 65.6675 122.117 70.8822 117.342 73.6326C114.768 75.1288 111.247 76.1629 106.715 75.4588C106.715 75.4588 102.512 72.4664 102.028 66.5696C101.588 61.399 104.448 56.5143 108.893 53.8079C109.443 53.4779 110.037 53.1479 110.675 52.8178C113.205 51.5636 115.56 49.9134 117.364 47.7131C118.728 46.0409 119.872 43.9946 119.872 41.8604L119.85 41.8824Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 60.7998C116.8 60.7998 114.702 67.8687 106.715 75.4597",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.2 75.2002C107.2 75.2002 94.1712 87.2002 92.7998 99.2002",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintTemp);
export default __webpack_public_path__ + "static/media/footprint_temp.2408db250767970ee7e7529607ac4b82.svg";
export { ForwardRef as ReactComponent };